import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Message from '../message/Message';

const useStyles = makeStyles(theme => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            maxWidth: '500px'
        }
    },
}));

export default function ConfirmationDialog(props) {
    const {
        open,
        onClose,
        onDisagree,
        onAgree,
        confirmationMessage = 'Tem certeza que deseja realizar essa ação?'
    } = props;
    const classes = useStyles();

    const handleDisagree = () => {
        if (onDisagree) {
            onDisagree();
        }

        onClose();
    };

    const handleAgree = () => {
        if (onAgree) {
            onAgree();
        }

        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby='Confirmação'
            classes={{ paper: classes.paper }}>
            <DialogTitle>Confirmação</DialogTitle>
            <DialogContent>
                <Message type='warning'>{confirmationMessage}</Message>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleDisagree}
                    color='primary'>
                    Não
                </Button>
                <Button
                    onClick={handleAgree}
                    color='primary'>
                    Sim
                </Button>
            </DialogActions>
        </Dialog>
    );
}

ConfirmationDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onDisagree: PropTypes.func,
    onAgree: PropTypes.func
};